import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { RoutePathConstants, PageTitleConstants } from "../../../Constants";
import { PageHeader, Loading, toastSuccessMessage } from "wup-module1-base";
import { Card } from "react-bootstrap";
import PageForm from "./Form/PageForm";
import { v4 as uuidv4 } from "uuid";

/**
 * DodawaniE strony
 * @returns Komponent dodawania strony
 */
function PageAdd() {
  const [isLoading, setIsLoading] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [model, setModel] = useState({});
  const { questionnaireId } = useParams();
  const navigate = useNavigate();

  const onSubmit = (model) => {
    setIsSubmitting(true);
    //DO IMPLEMENTACJI
    // PageService.create(model)
    //   .then((res) => {
    //     toastSuccessMessage(res.data);
    //     navigate(`/${RoutePathConstants.Page}`);
    //   })
    //   .catch((error) => {
    //     toast.error(error.response.data.detail);
    //   })
    //   .finally(() => {
    //     setIsSubmitting(false);
    //   });
    const pages = JSON.parse(sessionStorage.getItem("pages"));
    const questions = JSON.parse(sessionStorage.getItem("questions"));
    if (model.questions?.length > 0) {
      if (questions?.length > 0) {
        const questionIds = model.questions.map((i) => i.id);
        const currentIds = questions.map((i) => i.id);

        const toUpdate = questions.map((obj, idx) =>
          questionIds.includes(obj.id)
            ? model.questions.find((i) => i.id === obj.id)
            : obj
        );
        const toMerge = model.questions.filter(
          (i) => !currentIds.includes(i.id)
        );

        sessionStorage.setItem(
          "questions",
          JSON.stringify([...toUpdate, ...toMerge])
        );
      } else
        sessionStorage.setItem("questions", JSON.stringify(model.questions));
    }

    if (!!pages)
      sessionStorage.setItem(
        "pages",
        JSON.stringify([...pages, { ...model, order: pages.length + 1 }])
      );
    else
      sessionStorage.setItem("pages", JSON.stringify([{ ...model, order: 1 }]));
    setIsSubmitting(false);
    toastSuccessMessage(`Pomyślnie dodano stronę ${model.name}`);
    navigate(`/${RoutePathConstants.Page}`);
  };

  useEffect(() => {
    setIsLoading(true);
    const page = {
      id: uuidv4(),
      questions: [],
      questionnaireId: questionnaireId,
    };
    setModel(page);
    setIsLoading(false);
  }, []);

  return (
    <>
      <PageHeader content={PageTitleConstants.PageAdd} />
      <Card>
        <Card.Body>
          {isLoading ? (
            <Loading />
          ) : (
            <PageForm
              onSubmit={onSubmit}
              model={model}
              isSubmitting={isSubmitting}
            />
          )}
        </Card.Body>
      </Card>
    </>
  );
}

export default PageAdd;
